import React from 'react'
import EqxLoading from '../../shared/components/EqxLoading'
import useApiEndpoint from '../../shared/hooks/ApiEndpoint'
import generateContextProvider, { ContextProviderWrapperProps } from '../../shared/hooks/GenerateContextProvider'
import { useApiContext } from './AppApi'
import { useTenantID } from './AppDeploymentProvider'

interface AppTenant {
    id: string
    displayID: string
    name: string
    syncfusionLicenseKey?: string
    isLMSEnabled?: boolean
    lmsRootURL?: string
    isManagedPayroll: boolean
}

const TENANT_ERROR_QUERY_PARAM = 'tenantError'

const RedirectToTenantSelectorWithError = () => {
    React.useEffect(() => {
        const params = new URLSearchParams()
        params.set(TENANT_ERROR_QUERY_PARAM, '1')
        window.location.replace(`/switch?${params.toString()}`)
    }, [])

    return <EqxLoading />
}

const AppTenantWrapper = (props: ContextProviderWrapperProps<AppTenant>) => {
    const TenantProvider = props.provider
    const api = useApiContext()
    const tenantID = useTenantID()

    const confEndpoint = api.endpoints.config()
    const {
        status,
        response: loadedConfig,
        loading,
        error,
    } = useApiEndpoint(api, confEndpoint, true)

    //handle loading or error
    if (loading) return <EqxLoading />
    if (error) return <RedirectToTenantSelectorWithError />

    const Tenant: AppTenant = {
        id: tenantID,
        displayID: loadedConfig!.tenantDisplayID,
        name: loadedConfig!.tenantName,
        syncfusionLicenseKey: loadedConfig!.syncfusionLicenseKey,
        isLMSEnabled: loadedConfig!.isLMSEnabled,
        lmsRootURL: loadedConfig!.lmsRootURL,
        isManagedPayroll: loadedConfig!.isManagedPayroll
    }

    //pass auth on to the children
    return <TenantProvider value={Tenant}>{props.children}</TenantProvider>
}

const { ContextProvider: AppTenantProvider, useContext: useTenantContext } = generateContextProvider<AppTenant>(
    undefined,
    AppTenantWrapper
)

export { AppTenantProvider as default, useTenantContext, type AppTenant }

